import { CloseIcon } from "@chakra-ui/icons";
import { Button } from "@chakra-ui/react";
import { PrimitiveAtom, useAtom } from "jotai";
import { PropsWithChildren } from "react";

interface Props {
  leftIcon?: React.ReactElement;
  atom: PrimitiveAtom<boolean>;
  onClick: () => void;
}

export function Banner({
  atom,
  onClick,
  children,
  leftIcon,
}: PropsWithChildren<Props>) {
  const [ignored, setIgnored] = useAtom(atom);

  if (ignored) return null;

  return (
    <Button
      iconSpacing="auto"
      leftIcon={leftIcon}
      mb={4}
      onClick={onClick}
      rightIcon={
        <CloseIcon
          aria-label="Negeren"
          boxSize={4}
          cursor="pointer"
          onClick={(e) => {
            e.stopPropagation();
            setIgnored(true);
          }}
        />
      }
      variant="banner"
      w="full"
    >
      {children}
    </Button>
  );
}
